const onMenuOpen = (uuid:string) => {
    const menuSelector = `.Select_${uuid}__option--is-selected`;
    const observer = new MutationObserver(() => {
        const menu = document.querySelector(menuSelector);
        if (menu) {
            observer.disconnect();
            menu.scrollIntoView({
                behavior: 'auto',
                block: 'start',
                inline: 'start',
            });
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

export default onMenuOpen;